export default "__VITE_ASSET__bcedee18__"